import { useState, useRef, useEffect, memo } from "react"
import moment from "moment"

import { Notification } from "../../../utils/notification"
import NewCampaign from "./new"
import Loading from "../../../components/Loading"

const ITEMS_PER_PAGE = 10;

const CampaignItem = memo(function CampaignItem({ campaign }) {
  const [showPreview, setShowPreview] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !campaign.template?.html) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setShowPreview(true); },
      { rootMargin: "100px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [campaign.template?.html]);

  return (
    <div className="campaign" ref={ref}>
      <div className="preview">
        <div className="preview-html-overlay"></div>
        {showPreview ? (
          <div className="preview-html" dangerouslySetInnerHTML={{ __html: campaign.template.html }}></div>
        ) : (
          <div className="preview-html preview-placeholder"></div>
        )}
      </div>
      <div className="information">
        <h1>{campaign.title}</h1>
        <p><span className="status createdAt">Criada em</span> {moment(campaign.createdAt).format("DD/MM/YYYY")} às {moment(campaign.createdAt).format("HH:mm")}</p>
        <div className="audience-info">
          <i className="fas fa-paper-plane"></i> Enviada para {campaign.recipientsCount ?? campaign.recipients?.length ?? 0} pessoas.
        </div>
      </div>
    </div>
  );
});

export default function Campaigns({ admin, campaigns, campaignPagination, templates, audiences, clientsLength, leadsLength, createCampaign, refreshList, deleteCampaignsOlderThanOneYear, listTemplates }) {

  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(({ active: false, text: "" }))
  const [deleting, setDeleting] = useState(false)

  const pagination = campaignPagination || { total: 0, page: 1, limit: ITEMS_PER_PAGE };
  const totalPages = Math.ceil(pagination.total / pagination.limit) || 1;
  const currentPage = pagination.page;

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) refreshList(page, pagination.limit);
  };

  const handleDeleteOld = () => {
    if (!window.confirm("Excluir todas as campanhas com mais de 1 ano? Esta ação não pode ser desfeita.")) return;
    setDeleting(true);
    deleteCampaignsOlderThanOneYear(admin.loja, (result) => {
      setDeleting(false);
      if (result?.deleted !== undefined) {
        setNotification({ active: true, text: `${result.deleted} campanha(s) excluída(s).` });
        refreshList(1, pagination.limit);
      }
    });
  };

  return !campaigns ? <Loading /> : (
    <div className="campaigns">
      <Notification notification={notification} />

      <NewCampaign 
        loja={admin.loja} 
        active={modal} 
        close={() => { setModal(false); refreshList(currentPage, pagination.limit) }} 
        templates={templates} 
        audiences={audiences} 
        clientsLength={clientsLength} 
        leadsLength={leadsLength} 
        createCampaign={createCampaign} 
        setNotification={setNotification}
        listTemplates={listTemplates} 
      />

      <div className="section-actions">
        <button onClick={() => setModal(true)}><i className="fas fa-plus"></i> Nova Campanha</button>
        <button onClick={handleDeleteOld} disabled={deleting} className="btn-delete-old">
          <i className="fas fa-trash-alt"></i> Excluir campanhas com mais de 1 ano
        </button>
      </div>

      { campaigns?.map((campaign, index) => (
        <CampaignItem key={campaign._id || index} campaign={campaign} />
      )) }

      { totalPages > 1 && (
        <div className="campaigns-pagination">
          <button
            disabled={currentPage <= 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            <i className="fas fa-chevron-left"></i> Anterior
          </button>
          <span className="pagination-info">
            Página {currentPage} de {totalPages} ({pagination.total} campanhas)
          </span>
          <button
            disabled={currentPage >= totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Próxima <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      )}

    </div>
  )
}